require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

!function (e, t) {
  for (var r in t) {
    e[r] = t[r];
  }
}(exports, function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 10);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/ShapeType");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/PolygonMaskType");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/PolygonMaskInlineArrangement");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/PolygonMaskMoveType");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/Modes/HoverMode");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/Modes/ClickMode");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/InteractivityDetect");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/OutMode");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/MoveDirection");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    for (var r in e) {
      t.hasOwnProperty(r) || (t[r] = e[r]);
    }
  }

  var o = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(r(11));
  t.Particles = i["default"], n(r(7)), n(r(9)), n(r(8)), n(r(3)), n(r(4)), n(r(2)), n(r(17)), n(r(18)), n(r(1)), n(r(6)), n(r(19)), n(r(5)), t["default"] = i["default"];
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function o(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function i(e, t, r) {
    return (i = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, r) {
      var n = function (e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = c(e));) {
          ;
        }

        return e;
      }(e, t);

      if (n) {
        var o = Object.getOwnPropertyDescriptor(n, t);
        return o.get ? o.get.call(r) : o.value;
      }
    })(e, t, r || e);
  }

  function s(e, t) {
    return !t || "object" !== n(t) && "function" != typeof t ? a(e) : t;
  }

  function a(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function u() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function c(e) {
    return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function l(e, t) {
    return (l = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var p = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var r in e) {
      Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t["default"] = e, t;
  },
      f = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var d = p(r(0)),
      y = r(0),
      v = f(r(12)),
      b = r(13),
      h = r(14),
      m = r(15),
      _ = r(16),
      g = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && l(e, t);
    }(y, e);
    var t,
        r,
        n,
        p,
        f = (t = y, function () {
      var e,
          r = c(t);

      if (u()) {
        var n = c(this).constructor;
        e = Reflect.construct(r, arguments, n);
      } else e = r.apply(this, arguments);

      return s(this, e);
    });

    function y(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, y), (t = f.call(this, e)).state = {
        canvas: void 0,
        library: void 0
      }, t.loadCanvas = t.loadCanvas.bind(a(t)), t;
    }

    return r = y, (n = [{
      key: "buildParticlesLibrary",
      value: function value(e, t) {
        try {
          if (void 0 === window) return null;
        } catch (e) {
          return null;
        }

        var r = new m.Options();
        r.load(h.defaultParams), r.load(t), _.tsParticles.dom();
        var n = new b.Container(e, r);
        return this.props.particlesRef && (this.props.particlesRef.current = n), n;
      }
    }, {
      key: "refresh",
      value: function value(e) {
        var t = this,
            r = this.state.canvas;
        r && (this.destroy(), this.setState({
          library: this.buildParticlesLibrary(e.id, e.params)
        }, function () {
          t.loadCanvas(r);
        }));
      }
    }, {
      key: "destroy",
      value: function value() {
        this.state.library && this.state.library.destroy();
      }
    }, {
      key: "loadCanvas",
      value: function value(e) {
        var t = this;
        e && this.setState({
          canvas: e
        }, function () {
          var r = t.state.library;
          r && (r.canvas.loadCanvas(e), r.start());
        });
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e) {
        return !v["default"](e, this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        this.refresh(this.props);
      }
    }, {
      key: "forceUpdate",
      value: function value() {
        this.refresh(this.props), i(c(y.prototype), "forceUpdate", this).call(this);
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.setState({
          library: this.buildParticlesLibrary(this.props.id, this.props.params)
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.destroy(), this.setState({
          library: void 0
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.width,
            r = e.height,
            n = e.className,
            o = e.canvasClassName,
            i = e.id;
        return d.createElement("div", {
          className: n,
          id: i
        }, d.createElement("canvas", {
          ref: this.loadCanvas,
          className: o,
          style: Object.assign(Object.assign({}, this.props.style), {
            width: t,
            height: r
          })
        }));
      }
    }]) && o(r.prototype, n), p && o(r, p), y;
  }(y.Component);

  t["default"] = g, g.defaultProps = {
    width: "100%",
    height: "100%",
    params: h.defaultParams,
    style: {},
    id: "tsparticles"
  };
}, function (e, t) {
  e.exports = require("lodash/isEqual");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Classes/Container");
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = r(1),
      o = r(2),
      i = r(3),
      s = r(4),
      a = r(5),
      u = r(6),
      c = r(7),
      l = r(8),
      p = r(9);
  t.defaultParams = {
    particles: {
      number: {
        value: 40,
        max: -1,
        density: {
          enable: !1,
          value_area: 1200
        }
      },
      color: {
        value: "#FFF"
      },
      shape: {
        type: n.ShapeType.circle,
        stroke: {
          width: 0,
          color: "#000000"
        },
        polygon: {
          nb_sides: 5
        },
        image: {
          src: "",
          width: 100,
          height: 100
        }
      },
      opacity: {
        value: .5,
        random: !1,
        anim: {
          enable: !0,
          speed: 1,
          opacity_min: .1,
          sync: !1
        }
      },
      size: {
        value: 1,
        random: !1,
        anim: {
          enable: !1,
          speed: 40,
          size_min: 0,
          sync: !1
        }
      },
      line_linked: {
        enable: !0,
        distance: 150,
        color: "#FFF",
        opacity: .6,
        width: 1,
        shadow: {
          enable: !1,
          blur: 5,
          color: "lime"
        }
      },
      move: {
        enable: !0,
        speed: 3,
        direction: p.MoveDirection.none,
        random: !1,
        straight: !1,
        out_mode: l.OutMode.bounce,
        bounce: !0,
        attract: {
          enable: !1,
          rotateX: 3e3,
          rotateY: 3e3
        }
      }
    },
    interactivity: {
      detectsOn: c.InteractivityDetect.canvas,
      events: {
        onHover: {
          enable: !1,
          mode: a.HoverMode.grab
        },
        onClick: {
          enable: !1,
          mode: u.ClickMode.repulse
        },
        resize: !0
      },
      modes: {
        grab: {
          distance: 180,
          line_linked: {
            opacity: .35
          }
        },
        bubble: {
          distance: 200,
          size: 80,
          duration: .4
        },
        repulse: {
          distance: 100,
          duration: 5
        },
        push: {
          particles_nb: 4
        },
        remove: {
          particles_nb: 2
        }
      }
    },
    retina_detect: !0,
    fps_limit: 999,
    polygon: {
      enable: !1,
      scale: 1,
      type: o.PolygonMaskType.inline,
      inline: {
        arrangement: i.PolygonMaskInlineArrangement.onePerPoint
      },
      draw: {
        enable: !1,
        stroke: {
          width: .5,
          color: "rgba(255, 255, 255, .1)"
        }
      },
      move: {
        radius: 10,
        type: s.PolygonMaskMoveType.path
      },
      url: ""
    }
  };
}, function (e, t) {
  e.exports = require("tsparticles/dist/Classes/Options/Options");
}, function (e, t) {
  e.exports = require("tsparticles/dist/index");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/ProcessBubbleType");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/RotateDirection");
}, function (e, t) {
  e.exports = require("tsparticles/dist/Enums/Modes/DivMode");
}]));